import { useAuth } from "../context/AuthContext";
import { useTenant } from "../context/TenantContext";
import { useNotification } from "../context/NotificationContext";

import { createApiClient } from "./apiClient";
import { createPublicApi } from "./publicApi";
import { createAuthApi } from "./authApi";
import { createTenantApi } from "./tenantApi";

export function useApis() {
  const { isAuthenticated, ensureValidToken, getAccessToken } = useAuth();
  const { getTenant } = useTenant();

  const baseClient = createApiClient({
    isAuthenticated: isAuthenticated,
    ensureValidToken: ensureValidToken,
    getAccessToken: getAccessToken,
    getTenantId: () => getTenant()?.id,
  });

  return {
    publicApi: createPublicApi(baseClient),
    authApi: createAuthApi(baseClient),
    tenantApi: createTenantApi(baseClient),
  };
}
